



























import Vue from 'vue'

export default Vue.extend({
  name: 'Help',
  data () {
    return {
      publicPath: process.env.VUE_APP_API_URL
    }
  },
  computed: {
    pdfUrl (): string {
      return this.publicPath + '/sobree/resources/user-manual'
    },
    videoUrl (): string {
      return this.publicPath + '/sobree/resources/user-video'
    }
  }
})
